<div class="flex-col height100p">
    <sm-toolbar>
        <button pButton class="mr-3" icon="fas fa-filter" label="Filter" (click)="filter()"></button>
        <p-checkbox class="mr-3" label="Auch im Papierkorb suchen" name="includeTrash" [(ngModel)]="includeTrash" [binary]="true"></p-checkbox>
        <button pButton icon="fas fa-download" [disabled]="objects == null || objects.length == 0" label="Alle Dokumente herunterladen" (click)="download(true)"></button>
        <button pButton icon="fas fa-download" [disabled]="sel == null" label="Selektiertes Dokument herunterladen" (click)="download(false)"></button>
        <button pButton icon="fas fa-upload" [disabled]="sel == null" label="Selektiertes Dokument ersetzen" (click)="upload()"></button>
        <button pButton *ngIf="changed.length > 0" icon="fas fa-save" label="Änderungen speichern" (click)="saveChanges()"></button>
        <p-message *ngIf="notFoundText != null" severity="danger" [text]="'Die folgenden Objekt-IDs wurden nicht gefunden: ' + notFoundText"></p-message>
        <input pInputText class="width400" type="text" placeholder="Suche Test" [(ngModel)]="aiPrompt" (keypress)="aiPromptKeyPress($event)"/>
        <p-checkbox class="mr-3" label="Indexdaten in Tabelle anzeigen" name="indexDataInTable" [(ngModel)]="indexDataInTable" [binary]="true" (ngModelChange)="fillTable()"></p-checkbox>
        </sm-toolbar>
    <div class="flex-item-fill flex-row-split">
        <textarea pInputTextarea spellcheck=false placeholder="Objekt-IDs" class="flex-item-fixed width200 height100p monospace no-resize" [(ngModel)]="objectIds"></textarea>
        <div class="flex-item-fill flex-col">
            <sm-table2 *ngIf="table != null" class="flex-item-fixed height300" [data]="table" (onRowSelect)="selectObject($event)"></sm-table2>
            <p-tabView *ngIf="tableMetaData != null" class="flex-item-fill full-height direct-sub" [(activeIndex)]="tabIndex" (activeIndexChange)="tabIndexChanged()">
                <p-tabPanel header="Indexdaten">
                    <sm-table2 class="flex-item-fill height100p" [data]="tableMetaData" (onCellValueChanged)="cellEdited()"></sm-table2>
                </p-tabPanel>
                <p-tabPanel header="Maske">
                    <app-enaio-form [fields]="selectedObjectOtd?.fields" [doc]="sel"></app-enaio-form>
                </p-tabPanel>
                <p-tabPanel header="Basis">
                    <sm-table2 class="flex-item-fill height100p" [data]="tableBaseData"></sm-table2>
                </p-tabPanel>
                <p-tabPanel header="Historie">
                    <sm-table2 class="flex-item-fill height100p" [data]="tableHistory"></sm-table2>
                </p-tabPanel>
                <p-tabPanel header="Indexdaten-Historie">
                    <div class="flex-col height100p">
                        <sm-toolbar>
                            <p-button class="mr-5" icon="fas fa-cog" label="SimLog durchsuchen" (onClick)="getSimLog()"></p-button>
                            <p-message severity="danger" text="Hinweis: Die roten Markierungen in der obersten Zeile sind u.U. nicht zuverlässig"></p-message>
                        </sm-toolbar>
                        <sm-table2 class="flex-item-fill height100p" [data]="tableIndexDataHistory"></sm-table2>
                    </div>
                </p-tabPanel>
            </p-tabView>
        </div>
    </div>
</div>
<app-progressor-overlay [progressor]="progressor.value"></app-progressor-overlay>
